export { default } from './SideStripDesktop';
